var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 26.6445V30.0033H4V26.6445C4 22.4994 7.97064 19.3505 12.1776 19.1406H18.5388C22.7795 19.3505 27 22.4994 27 26.6445Z",
    fill: "#757FBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4967 16.8016C19.3585 16.8016 22.4892 13.712 22.4892 9.90078C22.4892 6.08958 19.3585 3 15.4967 3C11.6348 3 8.50415 6.08958 8.50415 9.90078C8.50415 13.712 11.6348 16.8016 15.4967 16.8016Z",
    fill: "#C3C7E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.045aba7d933a5efe88ea041c7adbb67d.svg";
export { ForwardRef as ReactComponent };